import {Component, OnInit} from '@angular/core';
import {ConfigService, MessageBusService} from '@shared-library';
import {CommonModule} from "@angular/common";
import {FdkButtonComponent, FdkIllustrationComponent} from "fasten-design-kit";

@Component({
    selector: 'app-complete',
    templateUrl: './complete.component.html',
    styleUrls: ['./complete.component.css'],
    standalone: true,
    imports: [
      CommonModule,
      FdkButtonComponent,
      FdkIllustrationComponent,
    ]

})
export class CompleteComponent implements OnInit {
  constructor(
    public configService: ConfigService,
    private messageBus: MessageBusService,
  ) { }

  ngOnInit(): void {

    //provide a close button that will bubble up an event to the parent frame, prompting this page to be closed.
    // all events were already sent at this point -- see: DashboardComponent.
    
  }

  closeModal() {
    //publish events for all connected accounts
    this.messageBus.publishComplete()
    this.messageBus.publishRequestClose()
  }
}
